import {APP_SETTINGS_PREFIX} from "./preferences_slice.js";
import {togglePreference} from "./toggle_preference.js";

export const toggleAppSetting = k => togglePreference(`${APP_SETTINGS_PREFIX}.${k}`);
